export const HourglassIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 178 255"
        >
            <g filter="url(#a)" opacity=".4">
                <ellipse
                    cx="65"
                    cy="16"
                    fill="#E3E3E3"
                    rx="65"
                    ry="16"
                    transform="matrix(1 0 0 -1 24 246.868)"
                />
            </g>
            <ellipse
                cx="89"
                cy="30.157"
                fill="#FCFCFC"
                rx="89"
                ry="30.157"
                transform="matrix(1 0 0 -1 0 239.182)"
            />
            <path
                fill="#FCFCFC"
                d="M71.755 140.07 8 197.868h164l-62.45-57.631c-10.655-9.833-27.054-9.905-37.795-.167Z"
            />
            <path
                fill="#394855"
                d="M26.37 187.803c-.098-.033-.1-.171-.001-.204 10.509-3.527 23.448-6.111 37.65-7.519 14.337-1.42 29.498-1.595 44.088-.509 14.589 1.087 28.137 3.4 39.394 6.727 11.061 3.269 19.561 7.413 24.748 12.063a.17.17 0 0 1-.095.294.172.172 0 0 1-.137-.044c-5.138-4.703-13.675-8.894-24.829-12.191-11.197-3.309-24.672-5.61-39.184-6.691-14.51-1.081-29.592-.907-43.852.506-14.245 1.412-27.213 4.014-37.713 7.568a.103.103 0 0 1-.07 0Zm147.606 12.524a.44.44 0 0 1 .371.146c4.29 4.916 4.812 10.122 1.512 15.127-3.338 5.062-10.472 9.747-20.713 13.602-10.242 3.855-23.245 6.75-37.753 8.404-14.507 1.655-30.03 2.014-45.066 1.042-15.036-.971-29.079-3.241-40.77-6.589-11.693-3.347-20.64-7.66-25.975-12.522-5.336-4.861-6.88-10.107-4.486-15.23 2.387-5.107 8.61-9.92 18.067-13.976a.284.284 0 0 1 .184-.014c.258.07.283.427.039.535-8.97 3.945-14.881 8.591-17.183 13.514-2.364 5.059-.839 10.238 4.43 15.039 5.269 4.8 14.102 9.059 25.647 12.364 11.544 3.306 25.41 5.547 40.257 6.506 14.848.96 30.174.605 44.499-1.029 14.325-1.634 27.164-4.492 37.276-8.298 10.113-3.807 17.157-8.432 20.453-13.431 3.15-4.777 2.773-9.741-1.083-14.451-.226-.276-.061-.702.294-.739Z"
                opacity=".3"
            />
            <ellipse
                cx="66.5"
                cy="20"
                fill="#E3E3E3"
                opacity=".3"
                rx="66.5"
                ry="20"
                transform="matrix(1 0 0 -1 29 228.868)"
            />
            <path
                fill="#E3E3E3"
                d="M143.384 200.408c3.603 2.57 5.616 5.437 5.616 8.46 0 11.046-26.863 20-60 20s-60-8.954-60-20c0-3.095 2.109-6.026 5.874-8.641l35.294-33.173c10.847-10.196 27.777-10.121 38.533.171l34.683 33.183Z"
            />
            <path
                fill="#394855"
                d="M145.198 207.911c0-2.879-1.916-5.608-5.348-8.055l-32.105-30.718a27.9 27.9 0 0 0-11.544-6.661l.17.179 14.84 15.822c14.12 15.053 6.636 39.748-13.466 44.429a86.401 86.401 0 0 1-56.98-6.254l-2.512-1.206c-3.013-1.446-5.399-3.537-7.13-5.997 2.35 9.798 26.948 17.505 56.945 17.505 31.552 0 57.13-8.526 57.13-19.044Z"
                opacity=".05"
            />
            <path
                fill="#fff"
                d="M76.822 148.304c-7.473 3.814-41.232 38.86-57.177 55.907 6.843-2.794 25.475-12.574 45.258-29.344 19.783-16.77 36.92-24.417 43.016-26.145-1.865-1.565-6.794-4.763-11.588-5.037-5.993-.342-10.167-.149-19.509 4.619Z"
                opacity=".5"
            />
            <path
                fill="#D9D9D9"
                d="M94 138.868a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-1 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
            />
            <path
                fill="#394855"
                d="M72.877 139.642 6.5 197.868l65.996-56.347c11.138-9.51 27.617-9.223 38.417.668l61.358 56.194-61.744-58.086c-10.507-9.884-26.805-10.168-37.65-.655Z"
                opacity=".3"
            />
            <path
                fill="#FCFCFC"
                d="m71.956 100.113-64.6-58.055H172.85l-63.28 57.889c-10.629 9.723-26.9 9.795-37.615.166Z"
            />
            <path
                fill="#E3E3E3"
                d="M131.788 77.213c2.703-1.927 4.212-4.078 4.212-6.345 0-8.284-20.147-15-45-15s-45 6.716-45 15c0 2.321 1.582 4.52 4.406 6.481l21.633 20.334c10.847 10.195 27.777 10.12 38.533-.172l21.216-20.298Z"
            />
            <path
                fill="#394855"
                d="M132.928 66.504c.647-.067 1.302.164 1.695.682 2.502 3.293 1.581 6.782-2.657 9.89-4.577 3.356-12.704 6.033-22.827 7.52-10.124 1.486-21.535 1.677-32.055.537-8.387-.91-15.738-2.614-21.195-4.883-1.338-.556-1.073-2.362.35-2.638a1.618 1.618 0 0 1 1.079.172c4.916 2.66 12.514 4.656 21.448 5.624 9.248 1.003 19.28.835 28.18-.472 8.899-1.307 16.044-3.66 20.068-6.611 2.456-1.802 3.645-3.748 3.539-5.696-.093-1.716.665-3.947 2.375-4.125Z"
                opacity=".1"
            />
            <path
                fill="#fff"
                d="M78.5 100.368c-6.4-2.8-36-29.833-50-43 5.833 2 21.8 9.2 39 22s31.833 18.333 37 19.5c-1.5 1.333-5.5 4.1-9.5 4.5-5 .5-8.5.5-16.5-3Z"
                opacity=".5"
            />
            <ellipse cx="89" cy="31.025" fill="#FCFCFC" opacity=".5" rx="89" ry="30.157" />
            <g opacity=".3">
                <path
                    fill="#394855"
                    d="M157.987 49.619c.219.059.243.358.034.445-13.916 5.792-33.69 9.632-55.499 10.768-22.142 1.153-44.753-.565-63.32-4.813-18.567-4.247-31.724-10.71-36.845-18.1-5.121-7.39-1.83-15.162 9.218-21.765C22.622 9.55 40.611 4.6 61.955 2.294 83.296-.013 106.42.493 126.712 3.71c20.291 3.217 36.256 8.908 44.709 15.937 8.41 6.995 8.767 14.803 1.008 21.88a.342.342 0 0 1-.272.087c-.289-.037-.401-.4-.19-.6 7.229-6.895 6.734-14.457-1.428-21.245-8.362-6.954-24.157-12.585-44.231-15.767C106.235.82 83.358.32 62.244 2.601 41.13 4.885 23.332 9.78 12.403 16.314c-10.93 6.533-14.186 14.222-9.12 21.532 5.067 7.31 18.084 13.704 36.453 17.906 18.368 4.202 40.737 5.902 62.642 4.761 21.865-1.139 41.662-5.024 55.455-10.884a.238.238 0 0 1 .155-.01Z"
                />
                <path
                    fill="#394855"
                    d="M170.384 42.719c.21.03.281.295.113.425a40.142 40.142 0 0 1-3.259 2.257.216.216 0 0 1-.153.028.217.217 0 0 1-.076-.396 38.344 38.344 0 0 0 3.189-2.264.242.242 0 0 1 .186-.05Z"
                />
            </g>
            <path
                fill="#394855"
                d="M72.826 100.298 6 41.868l66.447 56.55c11.066 9.418 27.394 9.192 38.195-.53L174 40.869l-63.738 58.914c-10.512 9.716-26.66 9.939-37.436.516Z"
                opacity=".3"
            />
            <circle cx="91.5" cy="120.368" r="8.5" fill="#D9D9D9" />
            <path
                fill="#EDEDED"
                d="M93.665 117.346c1.023-.417 1.534-1.618.805-2.448a5.977 5.977 0 0 0-6.193-1.782 5.982 5.982 0 0 0-4.169 6.865 5.98 5.98 0 0 0 1.871 3.311c.821.739 2.028.242 2.457-.776l1.222-2.905a2.002 2.002 0 0 1 1.089-1.076l2.918-1.189Z"
            />
            <defs>
                <filter
                    id="a"
                    width="146"
                    height="48"
                    x="16"
                    y="206.868"
                    colorInterpolationFilters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur result="effect1_foregroundBlur_1241_664" stdDeviation="4" />
                </filter>
            </defs>
        </svg>
    );
};
